module.exports = __webpack_public_path__ + "img/view.4eba64e8.png";